/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachPaperclipIcon16Regular = forwardRef('AttachPaperclipIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.658 2.573a3.431 3.431 0 0 1 4.853 4.852L8.826 13.11a4.772 4.772 0 1 1-6.748-6.748l4.006-4.006a.75.75 0 0 1 1.061 1.06L3.139 7.423a3.272 3.272 0 0 0 4.627 4.627l5.684-5.684a1.931 1.931 0 0 0-2.731-2.731L5.075 9.278a.59.59 0 1 0 .835.835l3.966-3.966a.75.75 0 1 1 1.06 1.06l-3.965 3.967a2.09 2.09 0 0 1-2.957-2.957l5.644-5.644Z" })));
});
